import { TThunkAction } from '../../types/redux';
import {
  ISetQuestionAnswerReactionWebResponse,
  ISetQuestionAnswerReactionWebResponse200,
  ISetQuestionAnswerReactionWebResponse400,
  fetchSetQuestionAnswerReactionWeb,
} from '../../repositories/newbuilding-reviews/v1/set-question-answer-reaction-web';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_answer_reaction_web/SetAnswerReactionWebRequestSchema';
import { EStatus } from '../../types/likes';
import { setAnswerReactionAction } from './actions';
import { mapLabelFromState, trackReactionAnalyticClick } from '../answers/analytics/reactionAnalytic';
import { getAnswerById } from '../../selectors/answers';
import { getObjectRating } from '../../selectors/objectInfo';

interface IParams {
  answerId: string;
  type: EStatus;
}

export function setQuestionAnswerReaction({ answerId, type }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    const siteType = context.custom.deviceType;
    const state = getState();
    const { like } = getAnswerById(answerId)(state);
    const rating = getObjectRating(state);

    try {
      const { response } = await fetchSetQuestionAnswerReactionWeb<
        ISetQuestionAnswerReactionWebResponse200,
        ISetQuestionAnswerReactionWebResponse400
      >({
        httpApi,
        parameters: { answerId, type: type as unknown as EType },
      });

      dispatch(
        setAnswerReactionAction({
          answerId,
          type: (response as ISetQuestionAnswerReactionWebResponse).type as unknown as EStatus,
        }),
      );

      const label = mapLabelFromState({
        currentState: like.status,
        nextState: (response as ISetQuestionAnswerReactionWebResponse).type as unknown as EStatus,
      });
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          review_id: answerId,
          type: 'answer_to_question',
        },
      };
      trackReactionAnalyticClick({ label, page });

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'question#setQuestionAnswerReaction',
        message: error.message,
      });

      return false;
    }
  };
}
